import { IStoreProps } from '../index';
import React from 'react';
import NotificationsItem from './notification-item/notification-item';
import DotsMenuPanel from './notification-item/dots-menu/dots-menu-panel';
import { useDispatch } from 'react-redux';

interface INotificationsListProps {
    storeProps: IStoreProps;
}

const NotificationsList = ({ storeProps }: INotificationsListProps) => {

    const { useAppSelector, rootActions } = storeProps;

    const dispatch = useDispatch();

    const notifications = useAppSelector(store => store.root.notifications);
    const additionalOpenedMenuNotification = useAppSelector(store => store.root.additionalOpenedMenuNotification);

    const onScroll = () => {
        dispatch(
            rootActions.main({
                additionalOpenedMenuNotification: null,
                additionalOpenedMenuStyles: null,
            })
        );
    };

    return (
        <>
            <p className="text-xl pb-2 pl-2">Notifications</p>
            <div className={ `overflow-auto px-2 flex flex-col` }
                 onScroll={ onScroll }
                 style={ {
                     maxHeight: '360px',
                 } }>
                {
                    notifications?.map(notification => {
                        return (
                            <NotificationsItem
                                key={ notification.userNTFGUID }
                                notification={ notification }
                                storeProps={ storeProps }
                            />
                        )
                    })
                }
            </div>

            {
                additionalOpenedMenuNotification &&
                <DotsMenuPanel storeProps={ storeProps }/>
            }
        </>
    )
};

export default NotificationsList;